import { c as _c } from "react/compiler-runtime";
import { Stack } from "@mui-wrapper";
import { AddCredits } from "@pages/settings/subscription-settings/credits/add-credits";
import NoCreditIcon from "@assets/illustrations/credits/no-credit.svg?react";
import { CREDITS_DISPLAY_NAME } from "@src/constants/credit-constants";
import { capitalizeFirstLetter } from "@utils/string-utils";
import { Text } from "@flat-ui";

/**
 * The component to show when the user doesn't have any credits(tokens) and never had any.
 */
export function NoCredits() {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      alignItems: "center",
      width: "100%",
      gap: "12px",
      paddingBottom: "32px",
      backgroundColor: "surfaces.secondary"
    };
    t1 = <NoCreditIcon />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Text variant="heading16" sx={{
      color: "text.secondary"
    }}>You don't have any {CREDITS_DISPLAY_NAME} yet.</Text>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      alignItems: "center",
      gap: "32px"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Stack sx={t0}>{t1}{t2}<Stack sx={t3}><Text variant="bodyS" sx={{
          color: "text.secondary",
          textAlign: "center"
        }}>{capitalizeFirstLetter(CREDITS_DISPLAY_NAME)} allow you and your team to generate floor plans within your projects. You can add{" "}{CREDITS_DISPLAY_NAME} anytime to start using them.</Text><AddCredits /></Stack></Stack>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}